import { Route } from "react-router";
import * as React from "react";
import * as WbContext from "../../workbench/stores/context";
import * as DocContext from "../../documents/stores/context";
import WorkbenchNewPage from "../screens/WorkbenchNewPage";
import WorkbenchNewSubjectPage from "../screens/WorkbenchNewSubjectPage";

const withWorkbenchProviders = (element: React.ReactNode) => (
    <WbContext.WorkbenchStoreProvider>
        <DocContext.DocumentsStoreProvider>
            {element}
        </DocContext.DocumentsStoreProvider>
    </WbContext.WorkbenchStoreProvider>
);

const workbenchNewRoute = () => {
    return (
        <>
            <Route
                path={"workbench-new"}
                element={withWorkbenchProviders(<WorkbenchNewPage />)}
            />
            <Route
                path={"workbench-new/:subjectId"}
                element={withWorkbenchProviders(<WorkbenchNewSubjectPage />)}
            />
        </>
    );
};

export default workbenchNewRoute;
